import { useState, useEffect, React } from "react";

import Logo from "../../../assets/images/logo.png";
import LocationIcon from "../../../assets/images/location.png";
import EmailIcon from "../../../assets/images/mail.png";
import CombinedStoreImage from "../../../assets/images/vertical-store.png";

import FacebookIcon from "../../../assets/images/facebook1.png";
import TwitterIcon from "../../../assets/images/twitter-gray.png";
import GlobeIcon from "../../../assets/images/dribble.png";
import InstagramIcon from "../../../assets/images/insta1.png";

export default function Footer() {
  // const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  useEffect(() => {
    if (openModal) {
      const timer = setTimeout(() => {
        setIsClosing(true); // Start fade-out animation

        setTimeout(() => {
          setOpenModal(false); 
          setIsClosing(false); // Reset fade-out for next time
        }, 300); // Match fade-out duration
      }, 1600);

      return () => clearTimeout(timer);
    }
  }, [openModal]);

  return (
    <footer className="w-full bg-[#F6F6F6] font-[inter] pt-20">

      <div className="max-w-[1200px] mx-auto px-6 pb-16 grid grid-cols-1 md:flex md:justify-between md:items-start gap-10">

        {/* COLUMN 1 — LOGO & DESC */}
        <div>
          <div className="inline-block bg-[#6A0DAD] p-3 rounded-lg mb-4">
            <img src={Logo} alt="Logo" className="w-[130px]" />
          </div>

          <p className="text-[#6E6E6E] leading-relaxed text-[16px] mb-6 max-w-[364px]">
            We are a modern on-demand laundry and dry-cleaning service that connects users with trusted local vendors. From doorstep pickup to timely delivery, we ensure clean, fresh, and perfectly cared-for clothes with just a few taps.
          </p>

          {/* Address */}
          <a
            href="https://www.google.com/maps/search/?api=1&query=3375+Pearl+Street+Sacramento,+India"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-2 mb-3 cursor-pointer"
          >
            <img src={LocationIcon} className="w-5" alt="Location" />
            <p className="text-sm text-[#6E6E6E] hover:text-black">
              3375 Pearl Street Sacramento, India
            </p>
          </a>

          {/* Email */}
          <a
            href="mailto:saaflo@gmail.com"
            className="flex items-start gap-2 cursor-pointer"
          >
            <img src={EmailIcon} className="w-5 mt-1" alt="Email" />
            <p className="text-sm text-[#6E6E6E] hover:text-black">
              saaflo@gmail.com
            </p>
          </a>
        </div>

        {/* COLUMN 2 — QUICK LINKS */}
        <div>
          <h3 className="font-semibold text-[18px] mb-4">Quick links</h3>

          <ul className="space-y-2 text-[#6E6E6E] text-[16px]">
            <li><a href="#home">Home</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#aboutus">About us</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        {/* COLUMN 3 — OPENING HOURS */}
        {/* <div>
          <h3 className="font-semibold text-[18px] mb-4">Opening Hours</h3>

          <ul className="space-y-2 text-[#6E6E6E] text-[16px]">
            <li>Monday - Friday</li>
            <li>9am - 8pm</li>
            <li>Sat-Sun: CLOSED</li>
          </ul>
        </div> */}

        {/* COLUMN 4 — APP BUTTON */}
        <div>
          <h3 className="font-semibold text-[18px] mb-4">Get The App</h3>
          <div onClick={() => setOpenModal(true)}>
            <img
              src={CombinedStoreImage}
              alt="Download App"
              className="w-[146px] cursor-pointer"
            />
          </div>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <div className="py-6 mt-4">
        <div className="max-w-[1200px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">

          <p className="text-[16px] text-[#6E6E6E]">
            © 2025 Saaflo. All rights reserved.
          </p>

          {/* SOCIAL ICONS */}
          <div className="flex items-center gap-4">
            <div className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full">
              <img src={FacebookIcon} className="w-5 h-5" alt="Facebook" />
            </div>

            <div className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full">
              <img src={TwitterIcon} className="w-5 h-5" alt="Twitter" />
            </div>

            <div className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full">
              <img src={GlobeIcon} className="w-5 h-5" alt="Dribbble" />
            </div>

            <a
              href="https://www.instagram.com/saafloapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="flex items-center justify-center w-10 h-10 bg-white border border-gray-200 rounded-full cursor-pointer">
                <img src={InstagramIcon} className="w-5 h-5" alt="Instagram" />
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* POPUP MODAL */}
      {openModal && (
        <div
          className={`fixed inset-0 z-50 flex items-center justify-center 
          bg-black bg-opacity-50 
          ${isClosing ? "animate-fadeOut" : "animate-fadeIn"}`}
        >
          <div className="bg-white p-6 rounded-lg shadow-lg w-[300px] text-center animate-slideUp animate-scaleIn">
            <h2 className="mb-3 text-xl font-bold text-gray-800">Coming Soon...</h2>
            <p className="mb-4 text-gray-600">App will be available soon.</p>

            <button
              onClick={() => setOpenModal(false)}
              className="px-4 py-2 text-white transition bg-[#6a0dad] rounded-md hover:bg-[#e2c9faff]"
            >
              OK
            </button>
          </div>
        </div>
      )}

    </footer>
  );
}
